import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=35d12606&"
import script from "./CardContent.vue?vue&type=script&lang=ts&"
export * from "./CardContent.vue?vue&type=script&lang=ts&"
import style0 from "./CardContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports